// Native blocking: mask blocked author content with a user-facing notice
import classNames from 'classnames';
import type { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';

import { blockedMessages } from '../../../../front/src/i18n/blocked';

type BlockedContentProps = PropsWithChildren<{
  className?: string;
}>;

export const BlockedContent = ({ children, className }: BlockedContentProps) => {
  return (
    <div className={classNames('border border-gray-200 rounded-md bg-gray-50 p-3', className)}>
      <p className="text-sm text-gray-600">
        <FormattedMessage {...blockedMessages.blockedContent} />
      </p>
      {children ? <div className="hidden">{children}</div> : null}
    </div>
  );
};
